export enum InvoiceTypeDisplayEnum {
	MANUAL_INVOICE = 'Manual Invoice',
	AUTO_INVOICE = 'Auto Invoice',
	FIRST_MONTH_INVOICE = 'First Month Invoice',
	CARRYOVER = 'Carryover',
	VALIDATION = 'Validation',
	HOTEL_STORAGE = 'Hotel Storage',
	OFFICE_RETAIL_RENT = 'Office Retail Rent',
	MISCELLANEOUS = 'Miscellaneous',
}
